export const redirectToMedia = (media: string) => {
  switch (media) {
    case "instagram":
      window.open("https://www.instagram.com/telemont.oficial/", "_blank");
      break;
    case "linkedin":
      window.open("https://www.linkedin.com/company/telemont/", "_blank");
      break;
    case "youtube":
      window.open("https://www.youtube.com/channel/UC8IWuAV6j3EY-OsKpzWioaQ", "_blank");
  }
}